<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Opret institution
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="form-groups">
									<div class="form-group">
										<div class="input-group" ref="namegroup">
											<label for="name">
												Navn
											</label>
											<input v-model="name" type="text" ref="name" value>
										</div>

										<div class="input-group" ref="addressgroup">
											<label for="address">
												Adresse
											</label>
											<input v-model="address" type="text" ref="address" value>
										</div>

										<div class="input-group" ref="cityAndZipcodegroup">
											<label for="address">
												Postnummer og by
											</label>
											<input v-model="cityAndZipcode" type="text" ref="cityAndZipcode" value>
										</div>
									</div>
									<div class="form-group">
										<div class="input-group" ref="emailgroup">
											<label for="email">
												Email
											</label>
											<input v-model="email" type="email" ref="email" value autocomplete="off">
										</div>

										<div class="input-group" ref="vatNumbergroup">
											<label for="address">
												CVR nummer
											</label>
											<input v-model="vatNumber" type="text" ref="vatNumber" value>
										</div>

										<div class="input-group" ref="contactNamegroup">
											<label for="address">
												Kontakt person
											</label>
											<input v-model="contactName" type="text" ref="contactName" value>
										</div>

										<div class="input-group" ref="notesgroup">
											<label for="notes">
												Noter
											</label>
											<textarea v-model="notes" ref="notes"></textarea>
										</div>
									</div>
								</div>
								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="close" class="text space">
										Tilbage
									</button>
									<button type="button" @click.prevent="saveData">
										Gem
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { appFeedbackStateEnum } from "@/app/enums/common";

	export default {
		name: "CustomerEdit",
		data()
		{
			return {
				dialogMode: "create",
				dialogTitle: "Opret institution",
				customerID: "0",

				name: "",
				address: "",
				cityAndZipcode: "",
				email: "",
				vatNumber: "",
				contactName: "",
				notes: "",
				customer: {
					name: "",
					address: "",
					cityandzipcode: "",
					email: "",
					vatnumber: "",
					contactname: "",
					notes: ""
				},
			}
		},
		mounted()
		{
			this.setModalIsVisible()

			if (this.$route.name == "CustomerEdit")
			{
				this.dialogMode = "edit"
				this.dialogTitle = "Rediger institution"
				this.customerID = this.$route.params.customerid
				this.loadData()
			}
			else
			{
				this.dialogMode = "create"
				this.dialogTitle = "Opret institution"
				this.$refs.name.focus()
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		methods:
		{
			checkForChanges()
			{
				var changes = false

				changes = changes || (this.name != this.customer.name)
				changes = changes || (this.email != this.customer.email)
				changes = changes || (this.vatNumber != this.customer.vatnumber)
				changes = changes || (this.contactName != this.customer.contactname)
				changes = changes || (this.notes != this.customer.notes)
				changes = changes || (this.address != this.customer.address)
				changes = changes || (this.cityAndZipcode != this.customer.cityandzipcode)

				if (changes)
				{
					return !confirm("Der er ændringer der ikke er gemt. Vil du lukke dialogen?")
				}

				return false;
			},
			close()
			{
				if (this.checkForChanges())
				{
					return;
				}

				this.$router.push({ name: "Customers" })
			},
			async loadData()
			{
				if (this.customerID)
				{
					this.setAppAsBusyModal();

					try
					{
						var result = await this.$store.dispatch(types.ACTION_GET_CUSTOMER, this.customerID);

						if (result.status == 200)
						{
							this.customer = result.data;
							this.name = result.data.name
							this.address = result.data.address
							this.cityAndZipcode = result.data.cityandzipcode
							this.email = result.data.email
							this.vatNumber = result.data.vatnumber
							this.contactName = result.data.contactname
							this.notes = result.data.notes
							this.dialogTitle = this.name
							this.setAppAsIdle()
						}
						else
						{
							this.setAppAsIdle()
							logError("CustomerEdit.loadData()", error)
							this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
							this.$router.push({ name: "Customers" })
						}
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("CustomerEdit.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
						this.$router.push({ name: "Customers" })
					}
				}
				else
				{
					alert("Forkert adresse. Opdater venligst siden, og prøv igen.");
					this.$router.push({ name: "Customers" })
				}
			},
			async saveData()
			{
				try
				{
					var valid = true
					var validationFocus = false

					if (this.name.length == 0)
					{
						this.$refs.namegroup.setAttribute("data-validation", "Indtast venligst et navn")
						this.$refs.name.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.namegroup.removeAttribute("data-validation")
					}

					if (this.address.length == 0)
					{
						this.$refs.addressgroup.setAttribute("data-validation", "Indtast venligst en adresse")
						if (!validationFocus) this.$refs.address.focus()
						valid = false
					}
					else
					{
						this.$refs.addressgroup.removeAttribute("data-validation")
					}

					if (this.cityAndZipcode.length == 0)
					{
						this.$refs.cityAndZipcodegroup.setAttribute("data-validation", "Indtast venligst postnummer og by")
						if (!validationFocus) this.$refs.cityAndZipcode.focus()
						valid = false
					}
					else
					{
						this.$refs.cityAndZipcodegroup.removeAttribute("data-validation")
					}

					// TODO: Validate email address
					if (this.email.length == 0 || this.email.indexOf("@") == -1 || this.email.indexOf(".") == -1)
					{
						this.$refs.emailgroup.setAttribute("data-validation", "Indtast venligst en korrekt e-mail adresse")
						if (!validationFocus) this.$refs.email.focus()
						valid = false
					}
					else
					{
						this.$refs.emailgroup.removeAttribute("data-validation")
					}

					if (this.vatNumber.length == 0)
					{
						this.$refs.vatNumbergroup.setAttribute("data-validation", "Indtast venligst CVR nummer")
						if (!validationFocus) this.$refs.vatNumber.focus()
						valid = false
					}
					else
					{
						this.$refs.vatNumbergroup.removeAttribute("data-validation")
					}

					if (this.contactName.length == 0)
					{
						this.$refs.contactNamegroup.setAttribute("data-validation", "Indtast navnet på kontakt personen")
						if (!validationFocus) this.$refs.contactName.focus()
						valid = false
					}
					else
					{
						this.$refs.contactNamegroup.removeAttribute("data-validation")
					}

					if (!valid)
					{
						return;
					}

					this.setAppAsBusyModal()

					var data =
					{
						id: this.customerID,
						name: this.name,
						address: this.address,
						cityAndZipcode: this.cityAndZipcode,
						email: this.email,
						vatNumber: this.vatNumber,
						contactName: this.contactName,
						notes: this.notes
					}

					if (this.dialogMode == "edit")
					{
						await this.$store.dispatch(types.ACTION_UPDATE_CUSTOMER, data)
							.then(response =>
							{
								this.customer = response.data
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.$router.push({ name: "Customers", params: { updatedCustomer: this.customer } })
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("Customer.saveData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen: ");
							});
					}
					else
					{
						await this.$store.dispatch(types.ACTION_ADD_CUSTOMER, data)
							.then(response =>
							{
								this.customer = response.data
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.ADDED)
								this.$router.push({ name: "CustomersRefresh", params: { addedCustomer: this.customer } })
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("Customer.saveData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
							});
					}
				}
				catch (error)
				{
					logError("Customer.saveData()", error)
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					this.setAppAsIdle()
				}
			}
		}
	};
</script>